module.exports = __webpack_public_path__ + "static/assets/22305c24b99b41c17f6296b6d69d1051.png";